import { useEffect, useState } from "react";
import { api, formatBRL } from "../lib/api";
import { Sparkles, Flame, Zap, Coins, Trophy, Crown, Star, Medal, Lock } from "lucide-react";

const ICONS = { sparkles: Sparkles, flame: Flame, zap: Zap, coins: Coins, trophy: Trophy, crown: Crown, star: Star, medal: Medal };

export default function Achievements() {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/achievements").then((r) => setList(r.data)).catch(() => {}); }, []);

  const unlocked = list.filter((a) => a.unlocked);
  const locked = list.filter((a) => !a.unlocked);

  return (
    <div className="arcade-grid min-h-screen pb-28">
      <div className="phone-frame phone-frame-full px-4 pt-6">
        <div className="mb-5">
          <p className="chip chip-gold mb-2">🏅 Suas conquistas</p>
          <h1 className="font-arcade text-3xl font-extrabold text-white tracking-tight">
            Conquistas
          </h1>
          <p className="text-sm text-slate-400 mt-1">
            {unlocked.length}/{list.length} desbloqueadas
          </p>
        </div>

        <h2 className="font-arcade text-sm font-bold text-amber-300 uppercase tracking-widest mb-3">
          Desbloqueadas
        </h2>
        <div className="grid grid-cols-2 gap-3 mb-6" data-testid="unlocked-grid">
          {unlocked.length === 0 && (
            <p className="col-span-2 text-sm text-slate-500 text-center py-4">
              Comece a vender para desbloquear 🚀
            </p>
          )}
          {unlocked.map((a) => {
            const Ico = ICONS[a.icon] || Trophy;
            return (
              <div key={a.code} className="neon-card-gold p-4 text-center bounce-in" data-testid="badge-card-unlocked">
                <div className="w-14 h-14 mx-auto rounded-2xl bg-gradient-to-br from-amber-400 to-pink-500 flex items-center justify-center shadow-xl shadow-amber-500/40 mb-2">
                  <Ico size={26} className="text-white" strokeWidth={2.4} />
                </div>
                <p className="font-arcade text-sm font-bold text-white">{a.title}</p>
                <p className="text-[11px] text-slate-300 mt-0.5">{a.description}</p>
              </div>
            );
          })}
        </div>

        <h2 className="font-arcade text-sm font-bold text-slate-400 uppercase tracking-widest mb-3">
          Bloqueadas
        </h2>
        <div className="grid grid-cols-2 gap-3" data-testid="locked-grid">
          {locked.map((a) => {
            const Ico = ICONS[a.icon] || Trophy;
            const pct = Math.min(100, (a.progress / a.target) * 100);
            return (
              <div key={a.code} className="neon-card p-4 text-center opacity-80" data-testid="badge-card-locked">
                <div className="relative w-14 h-14 mx-auto rounded-2xl bg-slate-800 flex items-center justify-center mb-2 grayscale">
                  <Ico size={24} className="text-slate-500" />
                  <div className="absolute -bottom-1 -right-1 w-6 h-6 rounded-full bg-slate-900 border border-slate-700 flex items-center justify-center">
                    <Lock size={11} className="text-slate-400" />
                  </div>
                </div>
                <p className="font-arcade text-sm font-bold text-slate-300">{a.title}</p>
                <p className="text-[11px] text-slate-500 mt-0.5">{a.description}</p>
                <div className="progress-track mt-2">
                  <div className="progress-fill" style={{ width: `${pct}%` }} />
                </div>
                <p className="text-[10px] font-mono text-slate-500 mt-1">
                  {a.metric === "total_value" ? formatBRL(a.current) : a.current}/{a.metric === "total_value" ? formatBRL(a.target) : a.target}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
